import { render, staticRenderFns } from "./sanjiPic.vue?vue&type=template&id=665051a8&"
import script from "./sanjiPic.vue?vue&type=script&lang=js&"
export * from "./sanjiPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports